import styled from 'styled-components'; 
import { Menu as MUIMenu, MenuItem as MUIMenuItem, Theme, SvgIcon } from '@material-ui/core';

const theme = (props: any) => {
  return props.theme as Theme;
}

export const StyledMenu = styled(MUIMenu)(props => ({

})) as typeof MUIMenu;

export const StyledMenuItem = styled(MUIMenuItem)(props => ({
  overflow: 'visible'
})) as typeof MUIMenuItem;

export const StyledMenuItemIcon = styled(SvgIcon)(props => ({
  paddingRight: theme(props).spacing(1),
})) as typeof SvgIcon;
